module.exports = "/_next/static/media/d7d192be786071785e5bef41b6ff1842.svg";